import { NavItem, NavItemsService } from '@abp/ng.theme.shared';
import { Component, OnInit, TrackByFunction } from '@angular/core';

@Component({
	selector: 'hedou-nav-items',
	templateUrl: './nav-items.component.html',
	styleUrls: ['./nav-items.component.less']
})
export class NavItemsComponent implements OnInit {

	trackByFn: TrackByFunction<NavItem> = (_, element) => element?.id;

	constructor(public readonly navItems: NavItemsService) { }

	ngOnInit(): void {
		
	}

}
